export const isDevelopmentEnv = () => {
    return process.env.REACT_APP_ENV === 'development'
}
export const isProductionEnv = () => {
    return process.env.REACT_APP_ENV === 'production'
}
